import { FaQuoteLeft } from "react-icons/fa"
import { MdOutlineStar } from "react-icons/md"

function TestimonialsSection() {
    const testimonials = [
        {
            name: "Mitchell",
            text: "Sage Apartments made our month-long stay in Kisumu effortless. The Lake Victoria view was breathtaking, and the team went above and beyond to make us feel at home.",
            rating: 5
        },
        {
            name: "Ochieng",
            text: "Finally, a place in Kisumu that understands hospitality. The apartment was spotless, Wi-Fi was fast for remote work, and the kitchen had everything I needed.",
            rating: 5
        },
        {
            name: "Priya",
            text: "We hosted our wedding reception with Sage and it was magical. The venue management team handled every detail perfectly. Highly recommend their catering services too!",
            rating: 5
        },
        {
            name: "Kamau",
            text: "As a local, I needed a comfortable space for my family visiting from abroad. Sage delivered comfort, convenience, and that home-away-from-home feeling.",
            rating: 5
        },
        {
            name: "Emma",
            text: "The 24/7 support was a lifesaver when my flight was delayed. The team arranged late check-in seamlessly. Professional, warm, and genuinely caring service.",
            rating: 5
        },
        {
            name: "Otieno",
            text: "I've stayed at several apartments in Kisumu for business, but Sage is unmatched. Smart home features, great location, and the concierge helped with everything.",
            rating: 5
        }
    ]

    return (
        <section className="py-10 bg-[#F8F9F7] mb-10">
            <div className="max-w-7xl px-8 mx-auto">
                <div className="text-center mb-10">
                    <span className="block text-xs uppercase tracking-widest font-label text-secondary mb-4">
                        Guest Experiences
                    </span>
                    <h2 className="text-3xl md:text-4xl font-headline text-primary mb-8 leading-tight">
                        What Our Guests Say
                    </h2>
                    <div className="w-24 h-1 bg-secondary mt-5 mx-auto"></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <div
                            key={index}
                            className="bg-white p-8 rounded-2xl border border-[#E5E7EB] hover:border-[#E87A25]/30 hover:shadow-lg transition-all duration-300 group"
                        >
                            <FaQuoteLeft className="text-[#E87A25]/20 text-4xl mb-6 group-hover:text-[#E87A25]/40 transition-colors" />

                            <div className="flex gap-1 mb-4">
                                {[...Array(testimonial.rating)].map((_, i) => (
                                    <MdOutlineStar key={i} className="text-[#E87A25] text-sm fill-current" />
                                ))}
                            </div>
                            <p className="text-[#6B7C76] text-sm leading-relaxed mb-6 italic">
                                "{testimonial.text}"
                            </p>
                            <div className="border-t border-[#E5E7EB] pt-4">
                                <p className="font-serif font-bold text-[#0F1715] text-base">
                                    {testimonial.name}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    )
}

export default TestimonialsSection